export { BoardTemplateBadge } from './BoardTemplateBadge';
